export default "__VITE_ASSET__CRFhn6OU__"